import ChartController from "./chart_controller.js"

// Connects to data-controller="chart-planungsvergleich"
export default class extends ChartController {
	changeChartSeries({ currentTarget, params }) {
		if (this.chartbuttonTargets.includes(currentTarget)) {
			this.chartbuttonTargets.forEach((e) => e.removeAttribute("data-ui"))
			currentTarget.dataset.ui = "aktiv"
		}

		switch (params.series) {
			case "liquiditaet":
				this.chart.updateSeriesData(this.chart.seriesLiqui())
				this.chart.updateYAxis(1) // 1 Y-Achse (x2)
				break
			case "nettovermoegen":
				this.chart.updateSeriesData(this.chart.seriesNetto())
				this.chart.updateYAxis(2) // 2 Y-Achsen (x2)
				break
			case "gesamtvermoegen":
				this.chart.updateSeriesData(this.chart.seriesGesamt())
				this.chart.updateYAxis(1) // 1 Y-Achse (x2)
				break
			default:
				console.error("Keine Series im Chart gefunden")
				this.charticonTargets.forEach((e) => e.classList.toggle("hidden"))
		}
	}

	showCashflowDifferenziert() {
		this.chart.chart.update({
			series: [
				{ id: "einnahmen1", visible: true, showInLegend: true },
				{ id: "einnahmen2", visible: true },
				{ id: "ausgaben1", visible: true, showInLegend: true },
				{ id: "ausgaben2", visible: true },
				{ id: "saldo1", visible: false, showInLegend: false },
				{ id: "saldo2", visible: false },
			],
		})
	}

	showCashflowSaldo() {
		this.chart.chart.update({
			series: [
				{ id: "einnahmen1", visible: false, showInLegend: false },
				{ id: "einnahmen2", visible: false },
				{ id: "ausgaben1", visible: false, showInLegend: false },
				{ id: "ausgaben2", visible: false },
				{ id: "saldo1", visible: true, showInLegend: true },
				{ id: "saldo2", visible: true },
			],
		})
	}
}
